import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { IonicModule } from '@ionic/angular';

import { ModalDeliveryShareComponent } from './modal-delivery-share.component';
import { SelectDropDownModule } from '../../select-drop-down/select-drop-down.module';
import {
  mainDeliveryShareKey,
  ModalDeliveryShareEffects,
  modalDeliveryShareReducer,
} from './store';

import { ModalDeliveryShareService } from './modal-delivery-share.service';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    SelectDropDownModule,
    StoreModule.forFeature(mainDeliveryShareKey, modalDeliveryShareReducer),
    EffectsModule.forFeature([ModalDeliveryShareEffects]),
  ],
  declarations: [ModalDeliveryShareComponent],
  providers: [ModalDeliveryShareService],
})
export class ModalDeliveryShareModule {}
